import { useCallback } from 'react';
import I18n from 'I18n';
import { isMarkActive, toggleMarkCommand } from '../utils/markUtils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { RTEToolbarButton } from '../components/StyledTextToolbarButton';
import { TextToolbarIcon } from 'rich-text-lib/components/editor/TextToolbarIcon';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import useDebouncedEditorStateContext from '../contexts/useDebouncedEditorStateContext';
import { Tracker } from '../../utils/usageTracker';
import { PM_FORMATTING } from '../constants/events';
import { CHANGE_INLINE_STYLE } from 'rich-text-lib/constants/usageTracking';
import { UnderlineIcon } from 'foundations-assets/icons/components/UnderlineIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export const toggleUnderline = toggleMarkCommand(schema => schema.marks.underline);
export default function UnderlineMark() {
  const {
    editorState,
    setEditorState
  } = useDebouncedEditorStateContext();
  const toggleUnderlineMark = useCallback(e => {
    e.preventDefault();
    toggleUnderline(editorState, tr => setEditorState(editorState.apply(tr)));
    Tracker.track(PM_FORMATTING, {
      action: CHANGE_INLINE_STYLE,
      method: 'toolbar',
      value: 'underline'
    });
  }, [editorState, setEditorState]);
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "hubspot-prosemirror.tooltips.underline"
    }),
    children: /*#__PURE__*/_jsx(RTEToolbarButton, {
      onMouseDown: toggleUnderlineMark,
      "data-test-id": "underline",
      "aria-label": I18n.text('hubspot-prosemirror.tooltips.underline'),
      selected: editorState && isUnderlined(editorState),
      children: /*#__PURE__*/_jsx(TextToolbarIcon, {
        icon: UnderlineIcon
      })
    })
  });
}
function isUnderlined(state) {
  return isMarkActive(state, state.schema.marks.underline);
}